<portal-sub-nav [force]="force" route="end-user-phone-book">
  <portal-menu-context [heading]="'menu.phonebook' | portalTranslate"></portal-menu-context>

  <portal-sub-nav-item route="end-user-phone-book-contacts">
    <ng-template portalTransclude>
      <span>{{ 'menu.contact' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <portal-sub-nav-item route="end-user-speed-dials">
    <ng-template portalTransclude>
      <span>{{ 'menu.speedDials' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <portal-sub-nav-item route="end-user-phone-book-export-import">
    <ng-template portalTransclude>
      <span>{{ 'menu.phonebook.export-import' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>
</portal-sub-nav>
